var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#303030",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4634 3.91029C12.7891 4.1662 12.8457 4.63769 12.5898 4.9634L9.98093 8.28372C9.72502 8.60943 9.25353 8.66601 8.92782 8.4101C8.60212 8.15419 8.54554 7.6827 8.80145 7.35699L11.4103 4.03667C11.6662 3.71096 12.1377 3.65438 12.4634 3.91029ZM3.51988 7.92387C3.83809 7.65869 4.31101 7.70169 4.57618 8.01989L6.48287 10.3079L7.25156 9.32958C7.50747 9.00388 7.97896 8.9473 8.30467 9.20321C8.63037 9.45912 8.68695 9.93061 8.43104 10.2563L7.24245 11.7691C6.86902 12.2443 6.15258 12.2546 5.76564 11.7903L3.42385 8.98017C3.15868 8.66196 3.20167 8.18904 3.51988 7.92387Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.e89e9406.svg";
export { ForwardRef as ReactComponent };